module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABUUlEQVRYR2NkGGDAOMD2Mwy8AzoT3jeQEwrlCwTJ0oduF2N3wof/5DigdIEAVUJvUDhgP5kh4IhPX2fSJ/XyeXw3CZlNlWBEt6Q/5rXkHxbWHf8Z/68umy/Ygs8RVHdAd+wLbkZmjo3/GRicQRYzMjKVl8zn68LlCKo7oCvhQygjA8MqZAsZGRmLSubz92NzBNUdALIEmyMYGBlzS+fzT8HIhoQSCbnyWEOCgSGzZIHADJTQIdcCYvRhc8R/RobUsvkCc2D6aRIFyI7D6giG/4llCwQXgBMpuUUxsiWEimWs0fGfMaZkIf9SsktCZAcQUyzjiI6IQeEAsopitBDAWyzjjQJiUjMlaggmQkoMJ6R3QLPhgBZEA1oUD3hlNODVMShhktQg6U74QJNygOgmGbmtYlKLYpwtogF3AD1qQ7o2SgmVjnRrkhHrEJq3iAg5BADm9aCFqQm9oAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/query-table/table2/images/plus.png
// module id = BaAA
// module chunks = 7